import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import counter from "../Assets/counter2.png"
import timer from "../Assets/Timer-removebg-preview.png"
import sewing from "../Assets/sewing_bg.png"
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

const MachineCardGrid = ({
    graph = [],
    runningStatus = {},
    colorWidthData = {},
    NavigateToLogs,
    machineTime,
    machineStatus,
    showShift,
    PrevshowShift,
    ButtonColor = () => { },
    machineKey = "machine_id",
    updateAnimation = true,
    isLoading = true
}) => {
    // console.log("propsdata", machineKey)
    // console.log("graph", graph)

    const borderRadius = (index, machineId) => {
        if (!colorWidthData[machineId]) return '0px';
        const isFirst = index === 0;
        const isLast = index === colorWidthData[machineId].length - 1;
        return isFirst ? '10px 0 0 10px' : isLast ? '0 10px 10px 0' : '0px';
    };

    const getAlarmColor = (item) => item.alarm_color || item.sensor_data?.alarm_color;
    const getCounterFlag = (item) => item.counter_flag || item.sensor_data?.counter_flag;
    const sensorName = (item) => item.sensor_name || item.sensor_data?.sensor_name;


    // console.log(getCounterFlag())
    const imageSrc = (item) => {
        if (item.device_id > 200) {
            return sewing;
        } else if (item.priority === "1") {
            return counter;
        } else {
            return timer;
        }
    };

    const backgroundcolor = (mech_id, data) => {
        if (runningStatus[mech_id]) {
            // console.log("machineTime" , runningStatus[mech_id].machine_current_status, data)
            if (runningStatus[mech_id].machine_current_status == "D") {
                return ("rgb(30, 42, 122)") //blue
            }
            else {
                if (runningStatus[mech_id].machine_current_state === "0") {
                    return "rgb(249, 113, 113)" //green
                }
                else if (runningStatus[mech_id].machine_current_state === "1") {
                    return "#F6E069" // orange
                }
                else {
                    return "#8FCD71" // red
                }
            }
        }
        else {
            return ("#D3D3D3") //gray
        }
    }


    //   if (runningStatus[mech_id].machine_current_status === "D") {
    //     color = 'rgb(30, 42, 122)';
    //   } else if (runningStatus[mech_id].machine_current_state === "0") {
    //     color = 'rgb(249, 113, 113)';
    //   } else if (runningStatus[mech_id].machine_current_state === "1") {
    //     color = '#F6E069';
    //   } else {
    //     color = '#8FCD71';
    //   }

    return (
        <div
            style={{
                width: "100%",
                flexWrap: "wrap",
                display: "inline-flex",
                justifyContent: "space-around",
                height: "80%",
                marginBottom: "40px",
            }}
        >

            {isLoading ? (
                <div style={{ width: "95%", margin: "50px 2.5%", justifyContent: "space-between", display: "inline-flex", flexDirection: "row" }}>
                    {[...Array(3)].map((_, index) => (
                        <div style={{ width: "25%" }} key={index}>
                            <Skeleton style={{ height: 150 }} />
                        </div>
                    ))}
                </div>
            ) : Object.keys(runningStatus).length === 0 ? (
                <div style={{ textAlign: 'center', marginTop: 50 }}>No machine connected or assigned to this device.</div>
            ) : (
                graph.map((item, index) => {

                    const machineId = item[machineKey];
                    const status = runningStatus[machineId];
                    const hasShift = status?.shift_status;
                    const prevData = status?.previousData;

                    return (
                        <div
                            key={index}
                            className={`machine_card draw ${updateAnimation ? 'animate' : ''}`}
                            style={{ backgroundColor: machineTime(machineId, getAlarmColor(item)), zIndex: 1}}
                        >

                            {status !== undefined ? (
                                hasShift ? (
                                    <div>
                                        <div style={{ paddingHorizontal: "2%" }}>


                                            <div style={{ paddingTop: 5, marginLeft: 5, position: 'relative' }} className="inLine">
                                                {/* <div style={{ position: "relative", display: "inline-block", zIndex: 3 }}
                                                    onClick={(e) => {
                                                        const icon = e.currentTarget;
                                                        icon.classList.remove("spin-once");
                                                        void icon.offsetWidth;
                                                        icon.classList.add("spin-once");
                                                    }}>
                                                    <i className="fa-solid fa-refresh" style={{ fontSize: "20px", zIndex: 3 }}
                                                    >
                                                        {machineStatus(machineId)}
                                                    </i>
                                                    <CountdownCircleTimer
                                                        isPlaying
                                                        size={30}
                                                        strokeWidth={3}
                                                        duration={10}
                                                        strokeLinecap="butt"
                                                        onComplete={() => {
                                                            return { shouldRepeat: true, delay: 0 }
                                                        }}
                                                        colors={ backgroundcolor(machineId, getAlarmColor(item))}
                                                        
                                                    >
                                                    </CountdownCircleTimer>
                                                    
                                                </div> */}

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        position: "relative",
                                                        padding: 5,
                                                        gap: 10,
                                                    }}
                                                >

                                                    <div style={{ position: "relative" }}>
                                                        <CountdownCircleTimer
                                                            isPlaying
                                                            size={20}
                                                            strokeWidth={4}
                                                            duration={30}
                                                            strokeLinecap="butt"
                                                            trailColor={backgroundcolor(machineId, getAlarmColor(item))}
                                                            onComplete={() => {
                                                                return { shouldRepeat: true, delay: 0 };
                                                            }}
                                                            colors="#d9d9d9"
                                                        />
                                                    </div>
                                                </div>


                                                <div style={{ marginLeft: 20, width: "70% " }}>
                                                    {/* <h4 className="TextMachName">{item.sensor_name}</h4> */}
                                                    <h4 className="TextMachName">{sensorName(item)}</h4>
                                                    <h4 className="TextMachName">{item.device_name}</h4>
                                                </div>
                                                <img
                                                    src={imageSrc(item)}
                                                    alt="Device"
                                                    style={{
                                                        width: item.device_id > 200 ? 50 : 60,
                                                        height: 50,
                                                        alignSelf: "flex-end",
                                                    }}
                                                />
                                            </div>


                                            {getCounterFlag(item) === "Y" ? (
                                                item.priority == "1" ? (
                                                    <div>
                                                        <div style={{ justifyContent: "space-between", display: "flex", flexDirection: "row", alignItems: "baseline" }}>
                                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "baseline" }}>
                                                                <span className=" machineEff" >{runningStatus[machineId]?.sensor_count}</span>
                                                                <span className=" machineEff" style={{ fontSize: 15, marginLeft: 5 }}>{runningStatus[machineId]?.counterUnit}</span>
                                                            </div>

                                                            {runningStatus.hasOwnProperty(machineId) ? (
                                                                <span style={{ width: "40%", flexWrap: "wrap" }}>
                                                                    {runningStatus[machineId].on_time}
                                                                </span>
                                                            ) : (
                                                                <span style={{ width: "40%", flexWrap: "wrap" }}>--:--</span>
                                                            )}

                                                            <span className="machineEff">
                                                                {runningStatus[machineId]?.efficiency ?? "NA"}%
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <div style={{ justifyContent: "space-between", display: "flex", flexDirection: "row", alignItems: "baseline" }}>
                                                            {runningStatus.hasOwnProperty(machineId) ? (
                                                                <span className=" machineEff" >{runningStatus[machineId].on_time}</span>
                                                            ) : (
                                                                <span>--:--</span>
                                                            )}

                                                            <div style={{ alignItems: "baseline", display: "flex", flexDirection: "row" }}>
                                                                <span>{runningStatus[machineId]?.sensor_count}</span>
                                                                <span style={{ fontSize: 15 }}> {runningStatus[machineId]?.counterUnit} </span>
                                                            </div>

                                                            <span className="machineEff">
                                                                {runningStatus[machineId]?.efficiency ?? "NA"}%
                                                            </span>
                                                        </div>
                                                    </div>
                                                )
                                            ) : (
                                                <div style={{ justifyContent: "space-between", display: "flex", flexDirection: "row", alignItems: "baseline" }}>
                                                    {runningStatus.hasOwnProperty(machineId) ? (
                                                        <span className=" machineEff">{runningStatus[machineId].on_time}</span>
                                                    ) : (
                                                        <span>--:--</span>
                                                    )}

                                                    <span className="machineEff">
                                                        {runningStatus[machineId]?.efficiency ?? "NA"}%
                                                    </span>
                                                </div>
                                            )}


                                            <div style={{ display: 'flex', width: '100%', height: '10px', borderRadius: '10px', marginBottom: "3px" }}>
                                                {colorWidthData[machineId]?.map(({ color, width }, i) => (
                                                    <div
                                                        key={i}
                                                        style={{
                                                            width,
                                                            backgroundColor: color,
                                                            borderRadius: borderRadius(i, machineId),
                                                        }}
                                                    ></div>
                                                )) ?? (
                                                        <div style={{ width: "100%", backgroundColor: "gray", borderRadius: "10px", height: "10px" }}></div>
                                                    )}
                                            </div>

                                            <div>
                                                <div style={{ margin: "5px" }} className="inLine">
                                                    <h4 className="shiftTime">Current Shift</h4>
                                                    <h5 className="shiftTimedata" style={{ margin: "0px 10px", color: "#49454F" }}>
                                                        {showShift(machineId) ?? "NA"}
                                                    </h5>
                                                </div>
                                            </div>

                                            <div style={{ justifyContent: "space-between", marginBottom: 5 }} className="inLine">
                                                <div style={{ marginHorizontal: 10 }}>
                                                    {prevData?.machine_time_id !== 0 && (
                                                        <div style={{ marginLeft: "5px" }}>
                                                            <h4 className="shiftTime">Previous Shift</h4>
                                                            <div className="inLine">
                                                                <h5 className="shiftTimedata" style={{ color: "#938F99" }}>
                                                                    {PrevshowShift(machineId)} /
                                                                </h5>
                                                                <h5 className="shiftTimedata" style={{ color: "#938F99" }}>
                                                                    {prevData.eff ?? "NA"}%
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                <div
                                                    className="DetailButton"
                                                    style={{ display: (ButtonColor() ? "flex" : "none"), backgroundColor: ButtonColor(machineId, getAlarmColor(item)), cursor: "pointer" }}
                                                    onClick={() => NavigateToLogs(item)}
                                                >
                                                    <h4 className="buttonText">View Detail</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <EmptyMachineCard item={item} />
                                )
                            ) : (
                                <EmptyMachineCard item={item} />
                            )}
                        </div>
                    );
                })
            )}


        </div>
    );
};

const EmptyMachineCard = ({ item }) => (
    <div style={{ width: "300px" }}>
        <div style={{ width: "100%" }}>
            <h4 style={{ width: "90%", fontSize: 21, fontFamily: "poppins, sans-serif", color: "black", textAlign: "center" }}>{item.sensor_name}</h4>
        </div>
        <div style={{ width: "100%", justifyContent: "space-between" }}>
            <h4 style={{ fontSize: 14, color: '#374955' }}>{item.device_name}</h4>
            <div>
                <h4 style={{ fontSize: 14, color: '#374955', paddingRight: 10 }}>Current Shift Not Exist</h4>
            </div>
        </div>
    </div>
);

export default MachineCardGrid;
